import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ApplicationState } from '../../../../store';
import Uploads, { IDispatchProps, IProps } from './index';
import { closeModal, openDocumentModal, openUploadModal } from '../../../../store/ui/actions';

import {
  approveDoc,
  acknowledgeDoc,
  updateVisaRefusalMetaData,
  noBiometrics,
  updateTBTestMetaData,
} from '../../../../store/student/documents/actions';
import { hasAnyMatchingDocs } from '../../../../utilities/documents';
import { saveDocuments, updateRisks } from '../../../../store/student/actions';
import { uiTypes } from 'shared-components';

const mapStateToProps = (state: ApplicationState): IProps => {
  const {
    country,
    passportStatus,
    passportExpectedDate,
    passportExpiryDate,

    hasEnglishTest,
    englishTestTypeOther,
    englishTestType,
    qualification,
    qualificationOther,
    englishTestNotReqdReason,
  } = state.student.personalInfo;

  const { courses, casReceived = false } = state.student.offer;

  const { lastCourse, lastCourseOther, lastCourseYear } = state.student.history;

  const docs = state.student.documents;

  const hasRequiredDocs = hasAnyMatchingDocs(docs, 'required');
  const hasInfoOnlyDocs = hasAnyMatchingDocs(docs, 'infoOnly');
  const hasStaffOnlyDocs = hasAnyMatchingDocs(docs, 'staffOnly');
  const hasAgentOnlyDocs = hasAnyMatchingDocs(docs, 'agentOnly');
  return {
    hasRequiredDocs,
    hasInfoOnlyDocs,
    hasStaffOnlyDocs,
    hasAgentOnlyDocs,
    documents: docs,
    userRole: state.auth.role,
    openModal: state.ui.openModal,
    country,
    passportStatus,
    passportExpectedDate,
    passportExpiryDate,
    lastCourse,
    lastCourseOther,
    lastCourseYear,
    hasEnglishTest: hasEnglishTest || false,
    englishTestTypeOther,
    englishTestType,
    qualification,
    qualificationOther,
    englishTestNotReqdReason,
    casReceived,
    courses,
    risks: state.student.risks,
    docsRequired: state.student.summary.docsRequired,
  };
};

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps => ({
  onUpdateRisks: (source: string, clearedRisks: any) => dispatch(updateRisks({ source, clearedRisks })),
  onContinue: (
    sponsorType: string | null,
    sponsorKey: string,
    docType: string | null,
    docKey: string | null,
    uploadedBy: string,
  ) => {
    dispatch(saveDocuments(sponsorType, sponsorKey, docType, docKey, uploadedBy));
    dispatch(closeModal());
  },
  openDocumentModal: (
    sponsorType: string | null,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle?: string,
  ) => {
    dispatch(openDocumentModal(sponsorType, sponsorKey, docType, docKey, modalTitle));
  },
  closeModal: () => {
    dispatch(closeModal());
  },
  openUploadModal: (
    sponsorType: string | null,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    modalTitle: string,
    fileNames: string[],
    metadata?: any,
  ) => {
    dispatch(openUploadModal(sponsorType, sponsorKey, docType, docKey, modalTitle, fileNames, metadata));
  },
  onApproveDoc: (
    sponsorType: string | null,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    docStatus?: string,
    docPrevStatus?: string,
  ) => {
    dispatch(approveDoc(sponsorType, sponsorKey, docType, docKey, docStatus, docPrevStatus));
  },
  onAcknowledgeDoc: (
    sponsorType: string | null,
    sponsorKey: string | null,
    docType: string | null,
    docKey: string | null,
    docStatus?: string,
    docPrevStatus?: string,
  ) => {
    dispatch(acknowledgeDoc(sponsorType, sponsorKey, docType, docKey, docStatus, docPrevStatus));
  },
  onVisaRefusalMetaDataUpdate: (
    sponsorType: string,
    sponsorKey: string,
    docType: string,
    docKey: string,
    metadata: any,
  ) => dispatch(updateVisaRefusalMetaData(sponsorType, sponsorKey, docType, docKey, metadata)),
  onNoBiometrics: (sponsorType: string, sponsorKey: string, docType: string, docKey: string) => {
    dispatch(noBiometrics(sponsorType, sponsorKey, docType, docKey));
    dispatch(closeModal());
  },
  onTBTestMetaUpdate: (sponsorType: string, docKey: string, metaData: uiTypes.ITBTestMetaData) =>
    dispatch(updateTBTestMetaData(sponsorType, docKey!, metaData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Uploads);
